module.exports = __webpack_public_path__ + "static/media/pink_animal_amphibians_5.b214d3fe.webp";